import React from 'react'

const Ships = ({ data, setShipId, shipId }) => {

    const ships = Array.isArray(data?.ships) ? data.ships : [];
    const showOverview = () => setShipId(null);

    return (
        <div className="overflow-section-left">
            <button
                type="button"
                className="top-title overview-title"
                onClick={showOverview}
            >
                Overview
            </button>
            <div className="halnk-section">
                {ships.length > 0 ? ships.map((item) => {
                    return (
                        <div key={item.SHIP_ID} className={`overflow-tab ${String(shipId) === String(item.SHIP_ID) ? 'active' : ''}`} onClick={() => { setShipId(item.SHIP_ID) }}>
                            <a href="javascript:void(0);">
                                <span className="overflow-tab-label">{item.HULL_NUMBER} - {item.SHIP_NAME}</span>
                                <span className="overflow-tab-count">{item.INSPECTION_COUNT}</span>
                            </a>
                        </div>
                    )
                }) : <div className="overflow-tab text-center">
                    No Hulls Available
                </div>}
            </div>
        </div>
    )
}

export default Ships
